import React from 'react';
import Grid from '@mui/material/Grid';

import { connect } from 'react-redux';

const OrdersHeader = () => {
  return (
    <Grid container className='page-header'>
      <Grid item size={{ xs: 12 }}>
        <h3>Órdenes de compra Dalefon</h3>
      </Grid>
    </Grid>
  );
};

// export default Modal;
const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersHeader);
